module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/ethmobile-45a22dfb033ec017bfbd7e7b222ecb5f.png";